
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import moment from 'moment'
import { isIterableArray } from '../../../utils/utils';
import PlanIventIcon from '../../../images/icons/PlanIventIcon';
import FinalIventIcon from '../../../images/icons/FinalIventIcon';
import ActIventIcon from '../../../images/icons/ActIventIcon';
import PaymentIventIcon from '../../../images/icons/PaymentIventIcon';
import ChangeIventIcon from '../../../images/icons/ChangeIventIcon';
import { ActiveDateType, CalendarIventType, CalendarType, IventType } from '../ContractPage.types';
import { Skeleton } from '@mui/material';
import CalendarDrawer from './CalendarDrawer';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { validateHeaderValue } from 'http';
import ModalViewBadgeItem from './ModalViewBadgeItem';
import { RolesType } from '../../../utils/roles';

// type IventType = {
//     type: 'plan' | 'final' | 'act' | 'payment' | 'change_condition',
//     text: string,
//     target_text: string
// }

// type CalendarType = {
//     day: string,
//     active: boolean,
//     data: IventType[] | []
// }

// ключ role - будет использован для блокировки просмотра бейджика в календаре 
export const IVENTS_DATA
    = {
    plan: {
        role: 'invoices',
        icon: <PlanIventIcon className='h-full w-full' />,
        name: 'contract_page.plan',
        bg: 'bg-ivent-plan'
    },
    final: {
        role: 'invoices',
        icon: <FinalIventIcon className='h-full w-full' />,
        name: 'contract_page.final',
        bg: 'bg-ivent-final'
    },
    act: {
        role: 'acts',
        icon: <ActIventIcon className='h-full w-full' />,
        name: 'contract_page.act',
        bg: 'bg-ivent-act'
    },
    payment: {
        role: 'payments',
        icon: <PaymentIventIcon className='h-full w-full' />,
        name: 'contract_page.payment',
        bg: 'bg-ivent-payment'

    },
    change_condition: {
        role: 'contract.payment',
        icon: <ChangeIventIcon className='h-full w-full' />,
        name: 'contract_page.change_condition',
        bg: 'bg-ivent-change'
    }
}

const Calendar = ({ roles, data, isFetching, activeDate }: {
    roles: RolesType | undefined
    data: CalendarType[] | undefined,
    isFetching: boolean,
    activeDate: ActiveDateType
}) => {

    const { t } = useTranslation()
    // const [calendar, setCalendar] = useState<CalendarType[]>([]);

    const service_id = useSelector((state: RootState) => state.contract.service_id)

    const [isOpenCalendarDrawer, setIsOpenCalendarDrawer] = React.useState(false);
    const [drawerValue, setDrawerValue] = useState<CalendarType>();

    const [isOpenItemModal, setIsOpenItemModal] = useState(false);
    const [modalItemValue, setModalItemValue] = useState(null);


    const handleClick = (event: React.MouseEvent<unknown>, data: CalendarType) => {
        setDrawerValue(data)
        openDrawer()
    };

    const openDrawer = () => setIsOpenCalendarDrawer(true);
    const closeDrawer = () => {
        if (!isOpenItemModal) setIsOpenCalendarDrawer(false)
    };

    const isToday = (day: string) => {
        const today = moment().format('DD-MM-YYYY')
        const checked = `${day}-${activeDate.month}-${activeDate.year}`
        return today === checked
    }

    const todayService = service_id === 1 ? '!text-orange-500 !border-orange-100' : service_id === 2 ? '!text-blue-500 !border-blue-100' : ''

    // const getKeys = Object.keys as <T extends object>(obj: T) => Array<keyof T>

    const DayEvents = ({ data }: { data: CalendarIventType[] }) => {
        const types: IventType[] = data.map(i => i.type)
        const uniqueSet: any = new Set(types)
        const uniqueArr: IventType[] = Array.from(uniqueSet)
        return (
            <div className='mt-auto grid grid-cols-5 tab:flex tab:flex-wrap gap-[1px]'>
                {
                    uniqueArr.length > 0 && uniqueArr.map((val: IventType) => {
                        const { icon, bg } = IVENTS_DATA[val]
                        return (
                            <div key={val} className={`rounded-full w-[12px] h-[12px] p-[2px] border border-white ${bg}`}>
                                {icon}
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    const handleClickBadge = (item: any) => {
        setIsOpenItemModal(true)
        setModalItemValue(item)
    }
    const closeModal = () => {
        setIsOpenItemModal(false);
        setModalItemValue(null)

    }


    return (
        <>
            <CalendarDrawer
                roles={roles}
                activeDate={activeDate}
                open={isOpenCalendarDrawer}
                closeDrawer={closeDrawer}
                drawerValue={drawerValue}
                handleClickBadge={handleClickBadge}
            />
            <ModalViewBadgeItem
                modalValue={modalItemValue}
                open={isOpenItemModal}
                handleClose={closeModal}
            />
            <div className='grow bg-white border-2 border-gray-100 rounded-[16px] p-[6px] mob:p-[12px] tab:p-[24px] lap:px-[32px] lap:py-[24px]'>
                <div className='grid grid-cols-7  gap-[4px] tab:gap-[8px] mb-[36px] text-sm pt-[24px] tab:pt-0'>
                    {[1, 2, 3, 4, 5, 6, 7].map(i => <div key={i} className={`${i > 5 ? 'text-gray-500' : 'text-gray-700'}  `}>{t(`short_day_${i}`)}</div>)}
                </div>
                <div className='grid grid-cols-7  gap-[4px] tab:gap-[8px]'>
                    {
                        isFetching ?
                            Array.from(Array(35).keys()).map(i => (
                                <div
                                    key={i}
                                    className={`rounded-[8px] min-h-[45px] tab:min-h-[64px]`}
                                >
                                    <Skeleton variant="rectangular" animation='pulse' className='!bg-gray-50 rounded-[6px] min-h-[45px] tab:min-h-[64px]' />
                                </div>
                            ))
                            :
                            data?.length ?
                                data.map((day: CalendarType, key) => (
                                    <div
                                        style={{ transitionProperty: 'none !important' }}
                                        key={key}
                                        className={`
                                            ${day.active ? 'bg-gray-50 border-gray-100 font-bold text-gray-700' : 'text-gray-500 border-gray-50'}
                                            border-2 rounded-[8px] text-[12px] mob:text-[14px] tab:text-[16px]
                                            py-[6px] px-[8px] tab:px-[16px] min-h-[45px] tab:min-h-[64px] flex flex-col justify--between
                                            transition-none hover:transition-all
                                            ${(day.active && isToday(day.day)) ? todayService : 'notoday'}
                                            ${isIterableArray(day.data) ? 'active:bg-gray-100 lap:hover:bg-gray-100 lap:hover:border-gray-200 lap:hover:cursor-pointer' : ''}
                                        `}
                                        onClick={(event: any) => {
                                            if (isIterableArray(day.data)) {
                                                handleClick(event, day)
                                            }
                                        }}
                                    >
                                        {day.day}
                                        {
                                            isIterableArray(day.data) &&
                                            <DayEvents data={day.data} />

                                        }
                                    </div>
                                ))
                                :
                                <div className='min-h-[400px]' />
                    }
                </div>
                <div className='mt-[24px] tab:mt-[45px] flex flex-col tab:flex-row flex-wrap gap-[8px] tab:gap-[15px] items-start tab:items-center justify-between'>
                    <div className='text-gray-800 text-[12px] tab:text-[16px]'>
                        {t('contract_page.type_ivent_title')}
                    </div>
                    <div className='grid grid-cols-3 tab:flex tab:flex-wrap gap-[5px]'>
                        {
                            Object.entries(IVENTS_DATA).map(([key, value]) => {
                                return (
                                    <div key={key} className={`flex flex-col justify-center tab:flex-row items-center gap-[4px] tab:gap-[5px] rounded px-[5px] py-[4px] ${value.bg} text-sm text-white`}>

                                        <div className={`hidden tab:block rounded-full w-[16px] h-[16px] p-[3px] border border-white`}>
                                            {value.icon}
                                        </div>
                                        <span className='text-[12px] tab:text-[14px] lowercase text-center tab:text-left leading-[1]'>
                                            {t(value.name)}
                                        </span>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default Calendar
